import { FC } from "react";

import { Sheet, SheetContent } from "@recobra/ui/sheet";

import { ProfileForm } from "./ProfileForm";

export const ProfileSheet: FC<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
}> = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="right">
      <ProfileForm />
    </SheetContent>
  </Sheet>
);
